import { useState } from "react";
import { useQuery } from "@apollo/client";


const useQueryLocationsSelect = ( query = true ) => {

    const [ searhText, setSearchText ] = useState('');

    const { loading, error, data } = useQuery( query, {
        variables: {
            text: searhText,
        }
    });

    const onSearch = ( value ) => { setSearchText( value ) }

    return {
        loadingQuery: loading,
        errorQuery: error,
        dataQuery: data?.locations.data,
        onSearch
    };
}

export default useQueryLocationsSelect;
